// extracted by mini-css-extract-plugin
export default {"list":"AuthNav_list__F71Og","link":"AuthNav_link__BaNlu","activeLink":"AuthNav_activeLink__d0ZDg"};